// This module provides API call methods for Sephora Commerce Profile APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Profile+APIs

const createUser = require('services/api/profile/createUser');

const {
    getPublicProfileByNickname,
    getCurrentProfileEmailSubscriptionStatus,
    lookupProfileByLogin,
    getProfileForPasswordReset
} = require('services/api/profile/getProfile');

const getProfileFullInformation = require('services/api/profile/getProfileFullInformation');

const {
    getProfileIdentifiersByNickname,
    getProfileIdentifiersByPublicId,
    getProfileIdentifiersByProfileId
} = require('services/api/profile/getProfileIdentifiers');

const { getShoppingList, addItemsToShoppingList, removeItemsFromShoppingList } = require('services/api/profile/shoppingList');

const getOrderHistory = require('services/api/profile/getOrderHistory');
const getReservations = require('services/api/profile/getReservations');
const updateProfile = require('services/api/profile/updateProfile');
const removePayPalFromProfile = require('services/api/profile/removePayPalFromProfile');
const cancelSubscription = require('services/api/profile/cancelSubscription');
const setNickname = require('services/api/profile/setNickname');
const removeDefaultPaymentFromProfile = require('services/api/profile/removeDefaultPaymentFromProfile');

const getCreditCardsFromProfile = require('services/api/profile/creditCards/getCreditCardsFromProfile');
const setDefaultCreditCardOnProfile = require('services/api/profile/creditCards/setDefaultCreditCardOnProfile');
const addCreditCardToProfile = require('services/api/profile/creditCards/addCreditCardToProfile');
const updateCreditCardOnProfile = require('services/api/profile/creditCards/updateCreditCardOnProfile');
const removeCreditCardFromProfile = require('services/api/profile/creditCards/removeCreditCardFromProfile');

const { getPromotionalEmailPreferences, setPromotionalEmailPreferences } = require('services/api/profile/mailingPreferences/promotionalEmails');

const {
    getNotificationsAndRemindersPreferences,
    setNotificationsAndRemindersPreferences
} = require('services/api/profile/mailingPreferences/notificationsAndReminders');

const { getPostalMailPreferences, setPostalMailPreferences } = require('services/api/profile/mailingPreferences/postalMail');

const getUserSpecificProductDetails = require('services/api/profile/getUserSpecificProductDetails');

const enrollToSephoraEmails = require('services/api/profile/enrollToSephoraEmails');

const getLithiumSSOToken = require('services/api/profile/getLithiumSSOToken');

const addShippingAddress = require('services/api/profile/addresses/addShippingAddress');
const getShippingAddresses = require('services/api/profile/addresses/getShippingAddresses');
const removeShippingAddress = require('services/api/profile/addresses/removeShippingAddress');
const updateShippingAddress = require('services/api/profile/addresses/updateShippingAddress');
const setDefaultShippingAddress = require('services/api/profile/addresses/setDefaultShippingAddress');

const { getProfileSamplesByDSG } = require('services/api/profile/getProfileSamples');
const switchCountry = require('services/api/profile/switchCountry');

const applySephoraCreditCard = require('services/api/profile/applySephoraCreditCard');
const getPreScreenDetails = require('services/api/profile/getPreScreenDetails');
const getProfileSettings = require('services/api/profile/getProfileSettings');
const getRealtimePreScreenDetails = require('services/api/profile/getRealtimePreScreenDetails');
const getTargetersContent = require('services/api/profile/getTargetersContent');

const switchPreferredStore = require('services/api/profile/reserveOnlinePickUpInStore/switchPreferredStore');
const getRopisSpecificProductDetails = require('services/api/profile/getRopisSpecificProductDetails');
const getSameDaySpecificProductDetails = require('services/api/profile/getSameDaySpecificProductDetails');
const updatePreferredZipCode = require('services/api/profile/updatePreferredZipCode');

const { getPersonalizedPromotions } = require('services/api/profile/promotions');
const updateBeautyPreferences = require('services/api/profile/updateBeautyPreferences');

module.exports = {
    createUser,

    getPublicProfileByNickname,
    getCurrentProfileEmailSubscriptionStatus,
    getProfileIdentifiersByNickname,
    getProfileIdentifiersByPublicId,
    getShoppingList,
    addItemsToShoppingList,
    removeItemsFromShoppingList,
    lookupProfileByLogin,
    getProfileForPasswordReset,
    getProfileFullInformation,
    getProfileIdentifiersByProfileId,
    getOrderHistory,
    getReservations,
    updateProfile,
    removePayPalFromProfile,
    cancelSubscription,
    setNickname,
    removeDefaultPaymentFromProfile,

    getCreditCardsFromProfile,
    setDefaultCreditCardOnProfile,
    addCreditCardToProfile,
    updateCreditCardOnProfile,
    removeCreditCardFromProfile,

    addShippingAddress,
    getShippingAddresses,
    removeShippingAddress,
    updateShippingAddress,
    setDefaultShippingAddress,

    getPromotionalEmailPreferences,
    setPromotionalEmailPreferences,
    getNotificationsAndRemindersPreferences,
    setNotificationsAndRemindersPreferences,
    getPostalMailPreferences,
    setPostalMailPreferences,

    getUserSpecificProductDetails,

    enrollToSephoraEmails,

    getLithiumSSOToken,

    getProfileSamplesByDSG,

    switchCountry,

    applySephoraCreditCard,
    getPreScreenDetails,
    getProfileSettings,
    getRealtimePreScreenDetails,
    getTargetersContent,

    switchPreferredStore,
    getRopisSpecificProductDetails,

    getSameDaySpecificProductDetails,
    updatePreferredZipCode,

    getPersonalizedPromotions,
    updateBeautyPreferences
};
